
import React from 'react';
import BaseComponent from './Base';
import Select from 'react-select';
import { Link } from 'react-router-dom';

class Documents extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : props.subModuleName,
        filterParams: [
          {value:'',name:"p",type:"string",default:''},
          {value:'',name:"lp",type:"string",default:''},
          {value:'',name:"lp2",type:"string",default:''},
          {value:'',name:"y",type:"string",default:''},
          {value:'',name:"t",type:"number",default:''},
          {value:'',name:"st",type:"number",default:''},
          {value:'',name:"l",type:"number",default:''},
          {value:'1',name:"s",type:"number",default:'1'},
        ]
      };

      super(props, config);
      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
      this.state.on_edit=(Paper_id,params)=>{
        this.setState({id_to_edit:Paper_id});
      };
    }
    componentWillReceiveProps(props){
      this.setSearchValues("p","");
      this.setSearchValues("lp","");
      this.setSearchValues("y","");
      this.setSearchValues("l","");
      this.setSearchValues("s","1");
      
      this.state.data = null;
      this.state.id_to_edit = null;
      this.state.subModuleName = props.subModuleName;
      this.state.list_url= '/api/organ/' + props.subModuleName + '/';
      this.state.get_url= '/api/organ/' + props.subModuleName + '/';

      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
         
      super.componentWillReceiveProps(props);
    }
    Years(){
      let years = [];
      years.push({value:"",label:"همه سالها"});
      for(let i=1400;i>1300;i--)years.push({value:i,label:i});
      return years;
    }
    _years(){
      var y = this.getFilterParamsValue("y").split(",");
      var list = [];
      y.forEach(_y => {
        if (!this.isBlank(_y))
          list.push({value:_y,label:_y})
      });
      return list;
    }
    _languages(e=null){
      var list = [
        {value:"",label:"هر زبانی"},
        {value:"1",label:"فارسی"},
        {value:"2",label:"انگلیسی"},
        {value:"3",label:"عربی"},
        {value:"4",label:"فرانسوی"},
        {value:"5",label:"روسی"},
        {value:"6",label:"آذری"},
        {value:"7",label:"ترکی"}
      ];
      if (e === null)
        return list;
      else
      {
        var r = null;
        list.forEach(_t=>{
          if (_t.value == e)
            r = _t;
        });
        return r;
      }
    }
    getFilters()
    {
      return(
      <form onSubmit={e=>this.refresh(e)}>
        <div className="row topSearchBar">
          <div className="col-sm-7">
            <input type="text" placeholder="جستجو در عنوان" defaultValue={this.getFilterParamsValue("p")} className="form-control text-center" onChange={e => this.setSearchValues('p',e.target.value)} />
          </div>
          <div className="col-sm-3">
            <Select
              placeholder="هر زبانی"                
              options={this._languages()}
              defaultValue={this._languages(this.getFilterParamsValue("l"))}
              onChange={e=>{
                this.setSearchValues('l',e.value);
                this.refresh();
              }}
            />
          </div>
          <div className="col-sm-2 recordCount">
            <button className="hand" type="submit">
              <i className="fa fa-search"></i>
            </button> | 
            <span> {this.money(this.state.data.record_count)} مقاله</span>
          </div>
        </div>
      </form>
      );
    }
    renderListView(){
      return [
          <div>
            <div className="row" style={{"marginBottom":"19px"}}>
              <div className="col-md-2 col-sm-2 col-xs-2">
                <Link className="btn btn-success" to={"/" + this.state.subModuleName + "/new/"}>
                  <i className="fa fa-plus"></i>
                  <span>افزودن مقاله جدید</span>
                </Link>   
              </div>
              <div className="col-md-10 col-sm-10 col-xs-10 text-left">
                {this.getToolBar(null,this)}
              </div>
            </div>
            {this.getFilters()}
            {this.state.data.records.length > 0 ?
              <div className="row">
                {this.state.data.records.map(_t=>
                  _t.source === 1 ?
                    <div className="col-md-4 col-sm-1 col-xs-1">
                      <div className="box box-success">
                        <div className="box-body">
                          <ul className="products-list product-list-in-box">
                            <div className="item">
                              <p className="message">
                                <Link to={"/" + this.state.subModuleName + "/edit/main/" + _t.id} className="name" style={{"min-height": "100px","display": "block"}}>{_t.title}</Link>
                                <span className="label label-info pull-left mr-r-5"><i className="fal fa-clock"></i> {this.g2j(_t.edit_date,0)}</span>
                                {<span className="label label-success pull-left">منتشر شده</span>}
                              </p>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  :
                    <div className="col-md-4 col-sm-1 col-xs-1">
                      <div className={_t.status === 1 ? "box box-warning" : _t.status === 2 ? "box box-success" : _t.status === 3 ? "box box-danger" : "box"}>
                        <div className="box-body">
                          <ul className="products-list product-list-in-box">
                            <div className="item">
                              <p className="message">
                                <Link to={"/" + this.state.subModuleName + "/edit/" + _t.id} className="name" style={{"min-height": "100px","display": "block"}}>{_t.title}</Link>
                                <span className="label label-info pull-left mr-r-5"><i className="fal fa-clock"></i> {this.g2j(_t.edit_date,0)}</span>
                                {_t.status === 1 && <span className="label label-warning pull-left">در انتظار بررسی و تایید</span>}
                                {_t.status === 2 && <span className="label label-success pull-left">منتشر شده</span>}
                                {_t.status === 3 && <span className="label label-danger pull-left">درخواست رد شده است</span>}
                                {_t.status === 3 && !this.isBlank(_t.note) && <p className="text-red">توضیحات مدیر سیستم: {_t.note}</p>}
                              </p>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                )}
              </div>
            :
              <h4 className="alert alert-info text-center">کاربر گرامی در حال حاضر شما مقاله ثبت شده ای ندارید</h4>
            }
          </div> 
        ];
    }
    render() {
      if (this.state.data === null || this.state.data === undefined) return this.showLoading();
      if (this.state.data.status === 2) return this.renderNoAccess();
      if (this.state.data.status === 404) return this.render404();
      if (this.state.data.status === 0 || this.state.data.status === 500) return this.render500();
      return this.renderListView()
    }
}
export default Documents;